export const CREDIT_CARD_FEE = 2.3;
